"use client";

/**
 * NewForm DS animated icon — a document with an upload arrow.
 * Outline draws on, then the arrow rises into place. Brand purple by
 * default. See ./shared for the animation/colour conventions.
 */

import { motion } from "motion/react";
import {
  type AnimatedIconProps,
  drawProps,
  IconSvg,
  riseProps,
  useReduce,
} from "./shared";

export function UploadFileIcon({ size, className }: AnimatedIconProps) {
  const reduce = useReduce();
  return (
    <IconSvg size={size} className={className}>
      <motion.path
        d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7z"
        {...drawProps(reduce, 0)}
      />
      <motion.path d="M14 2v5h5" {...drawProps(reduce, 0.18)} />
      <motion.g {...riseProps(reduce, 0.5)}>
        <path d="M12 18v-6" />
        <path d="m9 15 3-3 3 3" />
      </motion.g>
    </IconSvg>
  );
}
